import { useQuery } from "@tanstack/react-query";
import { getDoctorsList } from "../../../services/doctors";
import { useToast } from "../../../components/ui/use-toast";
import { useEffect } from "react";


export function useDoctorsList({
  enabled = true,
  page = 0,
  size = 10, // Align with MAX_ENTITY
}: { enabled?: boolean; page?: number; size?: number }) {
  const { toast } = useToast();

  const {
    data,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["doctors-list", enabled, page, size],
    queryFn: () => getDoctorsList({ page, size }),
    enabled,
  });

  useEffect(() => {
    if (isError) {
      toast({
        title: "Failed to fetch doctors list",
        variant: "destructive",
      });
    }
  }, [isError, toast]);

  return {
    doctors: data?.data ?? [],
    totalPages: data?.totalPages ?? 1,
    totalItems: data?.totalItems ?? 0,
    isLoading,
  };
}